import React, { useEffect } from "react";
import {
  fetchDataPrivacy,
  selectIdPrivacy,
} from "../../../pages/setting/settingSlice";
import { useDispatch, useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { year } from "../../../utility";

export const PrivacyPolicy = () => {
  const dispatch = useDispatch();
  const dataId = useSelector(selectIdPrivacy);

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(fetchDataPrivacy());
    }
    fetchMyAPI();
  }, [dispatch]);

  return (
    <div className="privacy-policy-page">
      {/* Header Section */}
      <div className="header-section text-center py-5">
        <img
          src={toAbsoluteUrl("/media/logos/Brand.png")}
          className="brand-logo mb-4"
          alt="Brand Logo"
          style={{ height: "80px" }}
        />
        <h1 className="display-4 font-weight-bold">Privacy Policy</h1>
        <p className="lead">Your privacy is important to us. Learn how we handle your information.</p>
      </div>

      {/* Privacy Policy Content Section */}
      <div className="container">
        <div className="policy-content p-5 my-5" style={{ backgroundColor: "#f9f9f9", borderRadius: "10px", boxShadow: "0 6px 12px rgba(0, 0, 0, 0.1)" }}>
          <div
            dangerouslySetInnerHTML={{
              __html: dataId?.privacy_policy_rules,
            }}
          ></div>
        </div>
      </div>

      {/* Footer Section */}
      <footer className="text-center py-4">
        <p className="mb-0">© {year} Pivore. All rights reserved.</p>
        <p>
          <a href="/terms" className="text-dark">Terms of Service</a> | <a href="/contact" className="text-dark">Contact Us</a>
        </p>
      </footer>
    </div>
  );
};
